export default __webpack_public_path__ + "static/media/ManageGroups.4bfddcb0.svg";